export default "__VITE_ASSET__BJtB1YRp__"